<template>
  <div
    :style="
      'color:' +
      (status === 'success' ? 'rgb(103, 194, 58)' : 'rgb(245, 108, 108)')
    "
    class="tip_one_warp"
  >
    <i :class="'el-icon-' + status"></i
    ><span>{{ newErrorMsg }}</span>
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      default: () => {
        return "";
      },
    },
    errorMsg:{
      type: String,
      default: () => {
        return "";
      },
    }
  },
  data() {
    return {};
  },
  computed: {
    newErrorMsg:function(){
      if(this.status === "success"){
       return this.errorMsg ?  this.errorMsg : "提交成功"
      } else {
        return this.errorMsg ?  this.errorMsg : "提交失败"
      }
    }
  },
  mounted() {
    console.log(this.status);
  },
};
</script>
<style lang="scss" scoped>
.tip_one_warp {
  display: inline;
  width: auto;
  i {
    font-size: 19px;
    vertical-align: middle;
  }
  span {
    font-size: 18px;
    vertical-align: middle;
  }
}
</style>